// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── ErpJson Page ──────────────────────────────────── */
.erpjson-page {
  min-height: 100vh;
  background: #f4f6f9;
  padding: 24px;
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
}

.erpjson-container {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 28px 32px 36px;
  box-sizing: border-box;
}

.erpjson-header {
  background: #f99022;
  margin: -28px -32px 24px;
  padding: 14px 28px;
  border-radius: 12px 12px 0 0;
}

.erpjson-header h2 {
  margin: 0;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.erpjson-header--list {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.erpjson-header-left {
  display: flex;
  align-items: center;
}

.erpjson-header-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 16px;
  font-size: 0.82rem;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  background: #fff;
  color: #f99022;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s, color 0.18s;
}

.erpjson-header-btn:hover {
  background: #ffe8cc;
}

/* ── Table ─────────────────────────────────────────── */
.erpjson-table-wrap {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #ececec;
  margin-top: 8px;
}

.erpjson-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
  font-family: 'Poppins', sans-serif;
}

.erpjson-table thead tr {
  background: #f99022;
  color: #fff;
}

.erpjson-table th {
  padding: 10px 14px;
  text-align: left;
  font-weight: 600;
  font-size: 0.76rem;
  white-space: nowrap;
}

.erpjson-table td {
  padding: 9px 14px;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
  vertical-align: middle;
}

.erpjson-table tbody tr:last-child td {
  border-bottom: none;
}

.erpjson-table tbody tr:hover {
  background: #fff8f0;
}

/* ── Edit button in table ──────────────────────────── */
.erpjson-edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  font-size: 0.76rem;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  color: #f99022;
  border: 1.5px solid #f99022;
  border-radius: 5px;
  background: #fff;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
}

.erpjson-edit-btn:hover {
  background: #f99022;
  color: #fff;
}

/* ── Edit icon button in table ─────────────────────── */
.erpjson-edit-icon-btn {
  color: #aaa !important;
  margin-right: 4px;
  transition: color 0.18s !important;
}

.erpjson-edit-icon-btn:hover {
  color: #f99022 !important;
}

/* ── Loading / empty states ────────────────────────── */
.erpjson-loading,
.erpjson-empty {
  padding: 40px 0;
  text-align: center;
  font-size: 0.88rem;
  color: #aaa;
}

/* ── Section title ─────────────────────────────────── */
.erpjson-section-title {
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #f99022;
  border-bottom: 2px solid #f990221a;
  padding-bottom: 4px;
  padding-top: 14px;
  margin-bottom: 12px;
}

.erpjson-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.2rem;
  margin-bottom: 12px;
}

/* ── Grid ──────────────────────────────────────────── */
.erpjson-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px 16px;
}

.erpjson-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.erpjson-field--wide {
  grid-column: span 2;
}

.erpjson-field label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #555;
}

.erpjson-field input,
.erpjson-select {
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  padding: 7px 10px;
  font-size: 0.85rem;
  font-family: 'Poppins', sans-serif;
  color: #222;
  outline: none;
  transition: border 0.2s;
  width: 100%;
  background: #fff;
  box-sizing: border-box;
}

.erpjson-field input:focus,
.erpjson-select:focus {
  border-color: #f99022;
  box-shadow: 0 0 0 2px #f9902220;
}

/* ── Cycle time ────────────────────────────────────── */
.erpjson-time {
  display: flex;
  align-items: center;
  gap: 6px;
}

.erpjson-time input {
  width: 70px;
  text-align: center;
}

.erpjson-time span {
  font-weight: 700;
  color: #666;
  font-size: 1rem;
}

/* ── Detail block ──────────────────────────────────── */
.erpjson-detail-block {
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  background: #fafafa;
}

.erpjson-detail-block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.erpjson-detail-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* ── Group label inside detail block ──────────────── */
.erpjson-group-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #bbb;
  margin-top: 14px;
  margin-bottom: 8px;
}

/* ── Item section header (title + Add Item btn) ─────── */
.erpjson-item-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed #e0e0e0;
}

/* ── Item divider inside detail block ──────────────── */
.erpjson-item-divider {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #bbb;
}

/* ── Item block (mirrors detail block, inset) ──────── */
.erpjson-item-block {
  border: 1px solid #e0e0e0;
  border-left: 3px solid #f99022;
  border-radius: 6px;
  padding: 12px 14px;
  margin-top: 8px;
  background: #fff;
}

.erpjson-item-block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.erpjson-item-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #f99022;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* ── Add button ────────────────────────────────────── */
.erpjson-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 14px;
  font-size: 0.78rem;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  color: #f99022;
  border: 1.5px solid #f99022;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
  white-space: nowrap;
}

.erpjson-add-btn:hover {
  background: #f99022;
  color: #fff;
}

.erpjson-add-btn--sm {
  padding: 3px 10px;
  font-size: 0.73rem;
}

.erpjson-add-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

/* ── Delete icon button ────────────────────────────── */
.erpjson-delete-btn {
  color: #e55 !important;
  flex-shrink: 0;
}

/* ── Action buttons ────────────────────────────────── */
.erpjson-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid #eee;
}

.erpjson-btn {
  padding: 8px 24px;
  font-size: 0.85rem;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: background 0.2s, color 0.2s;
}

.erpjson-btn--cancel {
  background: #fff;
  color: #666;
}

.erpjson-btn--cancel:hover {
  background: #f5f5f5;
}

.erpjson-btn--save {
  background: #f99022;
  color: #fff;
  border-color: #f99022;
}

.erpjson-btn--save:hover:not(:disabled) {
  background: #e08529;
}

.erpjson-btn--save:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ── Machine name column auto-width ────────────────── */
.erpjson-th-machine,
.erpjson-td-machine {
  white-space: nowrap;
  width: 1%;
}

/* ── Eye (item list) button ────────────────────────── */
.erpjson-eye-btn {
  color: #aaa !important;
  transition: color 0.18s !important;
}

.erpjson-eye-btn:hover,
.erpjson-eye-btn--active {
  color: #f99022 !important;
}

/* ── Delete icon button in table ──────────────────── */
.erpjson-delete-icon-btn {
  color: #aaa !important;
  transition: color 0.18s !important;
}

.erpjson-delete-icon-btn:hover {
  color: #e55 !important;
}

/* ── JSON View button in table ────────────────────── */
.erpjson-json-view-btn {
  display: inline-block;
  padding: 10px 12px;
  font-size: 0.76rem;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  color: #fff;
  background: #f99022;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.18s, opacity 0.18s;
  white-space: nowrap;
}

.erpjson-json-view-btn:hover:not(:disabled) {
  background: #e08529;
}

.erpjson-json-view-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Details expanded row ──────────────────────────── */
.erpjson-details-row td {
  background: #fffaf4;
  padding: 0 !important;
  border-bottom: 2px solid #f9902233;
}

.erpjson-details-section {
  padding: 14px 20px 16px 28px;
}

.erpjson-details-section-title {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #f99022;
  margin-bottom: 10px;
}

.erpjson-details-empty {
  font-size: 0.8rem;
  color: #aaa;
}

.erpjson-details-entry {
  margin-bottom: 10px;
}

.erpjson-details-machine {
  font-size: 0.78rem;
  font-weight: 700;
  color: #555;
  margin-bottom: 4px;
}

.erpjson-details-item-line {
  font-size: 0.8rem;
  color: #333;
  line-height: 1.6;
  padding-left: 4px;
}

.erpjson-item-id {
  font-weight: 600;
  color: #444;
}

.erpjson-item-desc {
  color: #666;
}

/* ── JSON Preview ──────────────────────────────────── */
.erpjson-preview {
  margin-top: 24px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.erpjson-preview-title {
  background: #f5f5f5;
  padding: 8px 16px;
  font-size: 0.8rem;
  font-weight: 700;
  color: #555;
  border-bottom: 1px solid #e0e0e0;
}

.erpjson-pre {
  padding: 16px 16px 16px 0px;
  font-size: 0.78rem;
  background: #fafafa;
  overflow-x: auto;
  color: #222;
  font-family: 'Courier New', monospace;
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/ErpjsonBuild/erpjson.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;;EAEE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;;EAEE,mBAAmB;EACnB,SAAS;AACX;;AAEA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,gBAAgB;AAClB","sourcesContent":["/* ── ErpJson Page ──────────────────────────────────── */\n.erpjson-page {\n  min-height: 100vh;\n  background: #f4f6f9;\n  padding: 24px;\n  font-family: 'Poppins', sans-serif;\n  box-sizing: border-box;\n}\n\n.erpjson-container {\n  width: 100%;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  padding: 28px 32px 36px;\n  box-sizing: border-box;\n}\n\n.erpjson-header {\n  background: #f99022;\n  margin: -28px -32px 24px;\n  padding: 14px 28px;\n  border-radius: 12px 12px 0 0;\n}\n\n.erpjson-header h2 {\n  margin: 0;\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n}\n\n.erpjson-header--list {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.erpjson-header-left {\n  display: flex;\n  align-items: center;\n}\n\n.erpjson-header-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 16px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  font-family: 'Poppins', sans-serif;\n  background: #fff;\n  color: #f99022;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.18s, color 0.18s;\n}\n\n.erpjson-header-btn:hover {\n  background: #ffe8cc;\n}\n\n/* ── Table ─────────────────────────────────────────── */\n.erpjson-table-wrap {\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid #ececec;\n  margin-top: 8px;\n}\n\n.erpjson-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n  font-family: 'Poppins', sans-serif;\n}\n\n.erpjson-table thead tr {\n  background: #f99022;\n  color: #fff;\n}\n\n.erpjson-table th {\n  padding: 10px 14px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.76rem;\n  white-space: nowrap;\n}\n\n.erpjson-table td {\n  padding: 9px 14px;\n  border-bottom: 1px solid #f0f0f0;\n  color: #333;\n  vertical-align: middle;\n}\n\n.erpjson-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.erpjson-table tbody tr:hover {\n  background: #fff8f0;\n}\n\n/* ── Edit button in table ──────────────────────────── */\n.erpjson-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 12px;\n  font-size: 0.76rem;\n  font-weight: 600;\n  font-family: 'Poppins', sans-serif;\n  color: #f99022;\n  border: 1.5px solid #f99022;\n  border-radius: 5px;\n  background: #fff;\n  cursor: pointer;\n  transition: background 0.18s, color 0.18s;\n}\n\n.erpjson-edit-btn:hover {\n  background: #f99022;\n  color: #fff;\n}\n\n/* ── Edit icon button in table ─────────────────────── */\n.erpjson-edit-icon-btn {\n  color: #aaa !important;\n  margin-right: 4px;\n  transition: color 0.18s !important;\n}\n\n.erpjson-edit-icon-btn:hover {\n  color: #f99022 !important;\n}\n\n/* ── Loading / empty states ────────────────────────── */\n.erpjson-loading,\n.erpjson-empty {\n  padding: 40px 0;\n  text-align: center;\n  font-size: 0.88rem;\n  color: #aaa;\n}\n\n/* ── Section title ─────────────────────────────────── */\n.erpjson-section-title {\n  font-size: 0.82rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #f99022;\n  border-bottom: 2px solid #f990221a;\n  padding-bottom: 4px;\n  padding-top: 14px;\n  margin-bottom: 12px;\n}\n\n.erpjson-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1.2rem;\n  margin-bottom: 12px;\n}\n\n/* ── Grid ──────────────────────────────────────────── */\n.erpjson-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px 16px;\n}\n\n.erpjson-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.erpjson-field--wide {\n  grid-column: span 2;\n}\n\n.erpjson-field label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #555;\n}\n\n.erpjson-field input,\n.erpjson-select {\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  padding: 7px 10px;\n  font-size: 0.85rem;\n  font-family: 'Poppins', sans-serif;\n  color: #222;\n  outline: none;\n  transition: border 0.2s;\n  width: 100%;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.erpjson-field input:focus,\n.erpjson-select:focus {\n  border-color: #f99022;\n  box-shadow: 0 0 0 2px #f9902220;\n}\n\n/* ── Cycle time ────────────────────────────────────── */\n.erpjson-time {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.erpjson-time input {\n  width: 70px;\n  text-align: center;\n}\n\n.erpjson-time span {\n  font-weight: 700;\n  color: #666;\n  font-size: 1rem;\n}\n\n/* ── Detail block ──────────────────────────────────── */\n.erpjson-detail-block {\n  border: 1px solid #ececec;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 12px;\n  background: #fafafa;\n}\n\n.erpjson-detail-block-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.erpjson-detail-label {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #aaa;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n/* ── Group label inside detail block ──────────────── */\n.erpjson-group-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #bbb;\n  margin-top: 14px;\n  margin-bottom: 8px;\n}\n\n/* ── Item section header (title + Add Item btn) ─────── */\n.erpjson-item-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px dashed #e0e0e0;\n}\n\n/* ── Item divider inside detail block ──────────────── */\n.erpjson-item-divider {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #bbb;\n}\n\n/* ── Item block (mirrors detail block, inset) ──────── */\n.erpjson-item-block {\n  border: 1px solid #e0e0e0;\n  border-left: 3px solid #f99022;\n  border-radius: 6px;\n  padding: 12px 14px;\n  margin-top: 8px;\n  background: #fff;\n}\n\n.erpjson-item-block-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.erpjson-item-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #f99022;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n/* ── Add button ────────────────────────────────────── */\n.erpjson-add-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 14px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  font-family: 'Poppins', sans-serif;\n  color: #f99022;\n  border: 1.5px solid #f99022;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  transition: background 0.18s, color 0.18s;\n  white-space: nowrap;\n}\n\n.erpjson-add-btn:hover {\n  background: #f99022;\n  color: #fff;\n}\n\n.erpjson-add-btn--sm {\n  padding: 3px 10px;\n  font-size: 0.73rem;\n}\n\n.erpjson-add-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* ── Delete icon button ────────────────────────────── */\n.erpjson-delete-btn {\n  color: #e55 !important;\n  flex-shrink: 0;\n}\n\n/* ── Action buttons ────────────────────────────────── */\n.erpjson-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 18px;\n  border-top: 1px solid #eee;\n}\n\n.erpjson-btn {\n  padding: 8px 24px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  font-family: 'Poppins', sans-serif;\n  border-radius: 6px;\n  cursor: pointer;\n  border: 1px solid #ddd;\n  transition: background 0.2s, color 0.2s;\n}\n\n.erpjson-btn--cancel {\n  background: #fff;\n  color: #666;\n}\n\n.erpjson-btn--cancel:hover {\n  background: #f5f5f5;\n}\n\n.erpjson-btn--save {\n  background: #f99022;\n  color: #fff;\n  border-color: #f99022;\n}\n\n.erpjson-btn--save:hover:not(:disabled) {\n  background: #e08529;\n}\n\n.erpjson-btn--save:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ── Machine name column auto-width ────────────────── */\n.erpjson-th-machine,\n.erpjson-td-machine {\n  white-space: nowrap;\n  width: 1%;\n}\n\n/* ── Eye (item list) button ────────────────────────── */\n.erpjson-eye-btn {\n  color: #aaa !important;\n  transition: color 0.18s !important;\n}\n\n.erpjson-eye-btn:hover,\n.erpjson-eye-btn--active {\n  color: #f99022 !important;\n}\n\n/* ── Delete icon button in table ──────────────────── */\n.erpjson-delete-icon-btn {\n  color: #aaa !important;\n  transition: color 0.18s !important;\n}\n\n.erpjson-delete-icon-btn:hover {\n  color: #e55 !important;\n}\n\n/* ── JSON View button in table ────────────────────── */\n.erpjson-json-view-btn {\n  display: inline-block;\n  padding: 10px 12px;\n  font-size: 0.76rem;\n  font-weight: 600;\n  font-family: 'Poppins', sans-serif;\n  color: #fff;\n  background: #f99022;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.18s, opacity 0.18s;\n  white-space: nowrap;\n}\n\n.erpjson-json-view-btn:hover:not(:disabled) {\n  background: #e08529;\n}\n\n.erpjson-json-view-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Details expanded row ──────────────────────────── */\n.erpjson-details-row td {\n  background: #fffaf4;\n  padding: 0 !important;\n  border-bottom: 2px solid #f9902233;\n}\n\n.erpjson-details-section {\n  padding: 14px 20px 16px 28px;\n}\n\n.erpjson-details-section-title {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #f99022;\n  margin-bottom: 10px;\n}\n\n.erpjson-details-empty {\n  font-size: 0.8rem;\n  color: #aaa;\n}\n\n.erpjson-details-entry {\n  margin-bottom: 10px;\n}\n\n.erpjson-details-machine {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #555;\n  margin-bottom: 4px;\n}\n\n.erpjson-details-item-line {\n  font-size: 0.8rem;\n  color: #333;\n  line-height: 1.6;\n  padding-left: 4px;\n}\n\n.erpjson-item-id {\n  font-weight: 600;\n  color: #444;\n}\n\n.erpjson-item-desc {\n  color: #666;\n}\n\n/* ── JSON Preview ──────────────────────────────────── */\n.erpjson-preview {\n  margin-top: 24px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.erpjson-preview-title {\n  background: #f5f5f5;\n  padding: 8px 16px;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #555;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.erpjson-pre {\n  padding: 16px 16px 16px 0px;\n  font-size: 0.78rem;\n  background: #fafafa;\n  overflow-x: auto;\n  color: #222;\n  font-family: 'Courier New', monospace;\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
